import React from "react";

export default function ColorFrame44({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          stroke="#3A2337"
          strokeWidth="12.678"
          d="M81.966 82.265c2.27-20.39 19.069-36.081 39.566-36.959l3.723-.159c20.449-.875 37.871 14.691 39.303 35.1l3.128 73.739c.16 3.776-2.999 6.852-6.769 6.593l-78.238-5.386a6.34 6.34 0 01-5.889-6.762l3.61-52.108 1.566-14.058z"
        ></path>
        <path
          stroke="#5F3A59"
          strokeWidth="12.678"
          d="M108.453 77.561c1.088-19.242 15.359-35.164 34.368-38.343 21.538-3.602 42.15 10.211 47.005 31.502l.933 4.091.002.007 18.453 81.329c.96 4.233-2.523 8.158-6.841 7.707l-89.996-9.4a6.34 6.34 0 01-5.68-6.398l.785-53.317.971-17.178z"
        ></path>
        <mask
          id="mask0_2256_162227"
          style={{ maskType: "alpha" }}
          width="116"
          height="139"
          x="100"
          y="32"
          maskUnits="userSpaceOnUse"
        >
          <path
            stroke="#5F3A59"
            strokeWidth="12.678"
            d="M108.453 77.561c1.088-19.242 15.359-35.164 34.368-38.343 21.538-3.602 42.15 10.211 47.005 31.502l.933 4.091.002.007 18.453 81.329c.96 4.233-2.523 8.158-6.841 7.707l-89.996-9.4a6.34 6.34 0 01-5.68-6.398l.785-53.317.971-17.178z"
          ></path>
        </mask>
        <g mask="url(#mask0_2256_162227)">
          <path
            stroke="#5F3A59"
            strokeWidth="12.678"
            d="M83.525 138.222l.413 53.39a6.339 6.339 0 005.785 6.266l151.913 13.314c4.648.408 8.128-4.177 6.487-8.544l-30.283-80.579-.003-.01M83.525 138.222l-6.34-.159c1.794-31.747 26.596-57.377 58.267-60.214l18.719-1.676c30.369-2.72 58.829 15.131 69.599 43.656l-5.933 2.23M83.525 138.222c1.709-28.515 24.02-51.51 52.492-54.06l18.719-1.675c27.531-2.466 53.332 13.715 63.101 39.572M83.525 138.222l134.312-16.163"
            opacity="0.5"
          ></path>
        </g>
        <path
          fill={fill}
          d="M6 176.434c0-45.338 36.753-82.091 82.091-82.091h98.889c45.338 0 82.092 36.753 82.092 82.091v66.243c0 7.002-5.677 12.678-12.679 12.678H18.678C11.676 255.355 6 249.679 6 242.677v-66.243z"
        ></path>
        <mask
          id="mask1_2256_162227"
          style={{ maskType: "alpha" }}
          width="264"
          height="162"
          x="6"
          y="94"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M6 176.434c0-45.338 36.753-82.091 82.091-82.091h98.889c45.338 0 82.092 36.753 82.092 82.091v66.243c0 7.002-5.677 12.678-12.679 12.678H18.678C11.676 255.355 6 249.679 6 242.677v-66.243z"
          ></path>
        </mask>
        <g mask="url(#mask1_2256_162227)">
          <path
            stroke={fill}
            strokeLinecap="round"
            strokeWidth="4.437"
            d="M258.492 129.044L239.08 287.215M16.143 129.044l19.411 158.171"
            opacity="0.5"
          ></path>
        </g>
        <path
          stroke={fill}
          strokeLinecap="round"
          strokeWidth="4.437"
          d="M85 115c28.56 4.483 81.48 3.486 105 0"
          opacity="0.5"
        ></path>
        <path
          fill={fill}
          d="M184.23 125.721a2.22 2.22 0 004.411-.49l-4.411.49zm3.759-6.114l-.163-2.212-4.425.326.163 2.212 4.425-.326zm.652 5.624c-.34-3.059-.493-3.471-.652-5.624l-4.425.326c.162 2.197.372 3.141.666 5.788l4.411-.49z"
          opacity="0.5"
        ></path>
        <rect
          width="100.157"
          height="100.157"
          x="87.775"
          y="137.618"
          fill="#fff"
          stroke="#A4CD9C"
          strokeWidth="6.339"
          rx="10.776"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
